// pages/Commission.jsx
import React, { useState } from 'react';
import { apiPost } from '../api/client';

const Commission = () => {
    // State for form data
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        artType: '',
        size: '',
        description: '',
    });

    const [status, setStatus] = useState('idle'); // idle | submitting | success | error
    const [errorMessage, setErrorMessage] = useState('');

    // Handle form input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('submitting');
        setErrorMessage('');

        try {
            await apiPost('/commissions', formData);
            setStatus('success');
            setFormData({
                name: '',
                email: '',
                phone: '',
                artType: '',
                size: '',
                description: '',
            });
        } catch (err) {
            setStatus('error');
            setErrorMessage('There was an error submitting your request. Please try again.');
        }
    };

    return (
        <div className="container">
            <div className="section-header" style={{ textAlign: 'center', marginBottom: '3rem' }}>
                <h2 className="section-title">Customized Art Commission</h2>
                <p style={{ maxWidth: '800px', margin: '0 auto', fontSize: '1.1rem' }}>
                    Commission a unique, personalized artwork from Samir Dutta that tells your story through
                    his distinctive folk modernist style.
                </p>
            </div>

            {/* Commission Request Form */}
            <section className="section">
                {status === 'success' && (
                    <div className="success-message" style={{
                        backgroundColor: 'rgba(62, 142, 87, 0.1)',
                        color: '#3e8e57',
                        padding: '1rem',
                        borderRadius: '4px',
                        marginBottom: '1.5rem',
                        borderLeft: '4px solid #3e8e57',
                        maxWidth: '800px',
                        margin: '0 auto 1.5rem'
                    }}>
                        <i className="fas fa-check-circle" style={{ marginRight: '0.5rem' }}></i>
                        Thank you for your commission request! Samir will contact you soon.
                    </div>
                )}

                {status === 'error' && (
                    <div className="error-message" style={{
                        backgroundColor: 'rgba(220, 53, 69, 0.1)',
                        color: '#dc3545',
                        padding: '1rem',
                        borderRadius: '4px',
                        marginBottom: '1.5rem',
                        borderLeft: '4px solid #dc3545',
                        maxWidth: '800px',
                        margin: '0 auto 1.5rem'
                    }}>
                        <i className="fas fa-exclamation-circle" style={{ marginRight: '0.5rem' }}></i>
                        {errorMessage}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="contact-form" style={{ maxWidth: '800px', margin: '0 auto' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem' }}>
                        <div className="form-group">
                            <label className="form-label">Full Name *</label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className="form-input"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Email Address *</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="form-input"
                                required
                            />
                        </div>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem' }}>
                        <div className="form-group">
                            <label className="form-label">Phone Number</label>
                            <input
                                type="tel"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                className="form-input"
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Art Type/Category *</label>
                            <select
                                name="artType"
                                value={formData.artType}
                                onChange={handleChange}
                                className="form-input"
                                required
                            >
                                <option value="">Select a category</option>
                                <option value="Mythology & Deities">Mythology & Deities</option>
                                <option value="Folk Narratives">Folk Narratives</option>
                                <option value="Contemporary Abstract">Contemporary Abstract</option>
                                <option value="Hindu Iconography">Hindu Iconography</option>
                                <option value="Divine Relationships">Divine Relationships</option>
                                <option value="Custom">Custom/Other</option>
                            </select>
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="form-label">Preferred Size</label>
                        <select
                            name="size"
                            value={formData.size}
                            onChange={handleChange}
                            className="form-input"
                        >
                            <option value="">Select preferred size</option>
                            <option value="Small (12'' x 12'')">Small (12" x 12")</option>
                            <option value="Medium (24'' x 24'')">Medium (24" x 24")</option>
                            <option value="Large (36'' x 36'')">Large (36" x 36")</option>
                            <option value="Extra Large (48'' x 60'')">Extra Large (48" x 60")</option>
                            <option value="Custom">Custom Size</option>
                        </select>
                    </div >

                    <div className="form-group">
                        <label className="form-label">Project Description/Vision *</label>
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            className="form-textarea"
                            placeholder="Please describe your vision for the artwork, including themes, colors, symbols, or any specific elements you'd like to include..."
                            required
                            rows="5"
                        ></textarea>
                    </div>

                    <button type="submit" className="btn" style={{ marginTop: '1rem' }} disabled={status === 'submitting'}>
                        {status === 'submitting' ? 'Submitting...' : 'Submit Commission Request'}
                    </button>
                </form >
            </section >
        </div >
    );
};

export default Commission;
